import React, { useEffect, useState } from 'react'
import Dialog from "../../components/Dialog"
import { ToastContainer, toast } from 'react-toastify'
import { ArrowRightLong, Bars, Bell, BookOpen, Calculator, CalendarAlt, ChartLine, Check, CircleCheck, CircleExclamation, CircleInfo, CircleXmark, ClipboardList, Clock, CommentDots, Cross, Crown, FileArrowUp, FileCircleXmark, Flag, Hammer, House, IdCard, NoteSticky, PaperPlane, Pause, PencilLine, Receipt, RupeesIcon, Search, ShieldHalved, TriangleExclamation, UserLarge, UserTie } from '../../components/icons/Icons'
import { Col, Form, Row } from 'react-bootstrap'
import { useSelect } from '../../services/commonServices'
import { useDispatch } from 'react-redux'
import { saveTdsStatusData, initStatusState } from '../../redux/slices/tdsSlice'
import { manageTDSFormsPath } from '../../services/config'
import { currentFynencialYear } from '../../services/commonServices'

const TdsDialoge = ({
    staffId = null,
    selectedRows = null,
    isApproved = false,
    closeApproveDialog = null,
    isRequestEdit = false,
    closeRequestEditDialog = null,
    isHold = false,
    closeHoldDialog = null,
    isRejected = false,
    closeRejectDialog = null,
    isImpact = false,
    closeImpactDialog = null,
    submitImpactForm = null,
    onActionComplete = null,
    financialYear = null
}) => {
    // Extract user_id safely
    const userData = JSON.parse(localStorage.getItem("user_data") || "{}")
    const userId = Number(userData.user_id || userData.id || userData.userId || 0)

    const tdsStore = useSelect("tds") || {}
    const dispatch = useDispatch()

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [processedCount, setProcessedCount] = useState(0)
    const [totalCount, setTotalCount] = useState(0)

    const [updateStatus, setUpdateStatus] = useState({
        otherIssuesForm12b: "",
        hrNotesEdit: "",
        markUsUrgent: "0",
        ccToEmployeeManager: "0",
        otherIssuesProofs: "",
        hrNotesHold: "",
        notifyEmployeeHoldStatus: "0",
        notifyAutoEscalateEmployee: "0",
        otherIssueReject: "",
        hrNotesReject: "",
        ccNotesRejectEmployee: "0",
        escalateHrDirectorReject: "0",
    })

    const [issuesToAddress, setIssuesToAddress] = useState([])
    const [holdReason, setHoldReason] = useState([])
    const [rejectedReason, setRejectedReason] = useState([])

    const isBulk = selectedRows && Array.isArray(selectedRows) && selectedRows.length > 0
    const allStaffIds = isBulk 
        ? selectedRows.map(row => row.id || row.staffId || row.employeeId).filter(Boolean)
        : staffId ? [staffId] : []

    const getEmployeeName = () => {
        if (isBulk) return `${allStaffIds.length} Employee${allStaffIds.length > 1 ? 's' : ''}`
        try {
            const tdsUser = JSON.parse(localStorage.getItem("tdsUser") || "{}")
            return tdsUser.employeeName || "Employee"
        } catch {
            return "Employee"
        }
    }

    const fy = financialYear || currentFynencialYear()

    // Input handlers
    const handleInputChange = ({ target: { name, value } }) => {
        setUpdateStatus(prev => ({ ...prev, [name]: value }))
    }

    const handleCheckBox = ({ target: { checked, name } }) => {
        setUpdateStatus(prev => ({ ...prev, [name]: checked ? "1" : "0" }))
    }

    const handleAddress = ({ target: { checked, value } }) => {
        setIssuesToAddress(prev => {
            if (checked) return [...prev, value]
            const updated = prev.filter(v => v !== value)
            if (value === "5") setUpdateStatus(prev => ({ ...prev, otherIssuesForm12b: "" }))
            return updated
        })
    }

    const handleHoldReason = ({ target: { checked, value } }) => {
        setHoldReason(prev => {
            if (checked) return [...prev, value]
            const updated = prev.filter(v => v !== value)
            if (value === "4") setUpdateStatus(prev => ({ ...prev, otherIssuesProofs: "" }))
            return updated
        })
    }

    const handleRejectedReason = ({ target: { checked, value } }) => {
        setRejectedReason(prev => {
            if (checked) return [...prev, value]
            const updated = prev.filter(v => v !== value)
            if (value === "4") setUpdateStatus(prev => ({ ...prev, otherIssueReject: "" }))
            return updated
        })
    }

    const resetForm = () => {
        setUpdateStatus({
            otherIssuesForm12b: "",
            hrNotesEdit: "",
            markUsUrgent: "0",
            ccToEmployeeManager: "0",
            otherIssuesProofs: "",
            hrNotesHold: "",
            notifyEmployeeHoldStatus: "0",
            notifyAutoEscalateEmployee: "0",
            otherIssueReject: "",
            hrNotesReject: "",
            ccNotesRejectEmployee: "0",
            escalateHrDirectorReject: "0",
        })
        setIssuesToAddress([])
        setHoldReason([])
        setRejectedReason([])
        setIsSubmitting(false)
        setProcessedCount(0)
        setTotalCount(0)
    }

    const cancel = () => {
        resetForm()
        closeApproveDialog?.()
        closeRequestEditDialog?.()
        closeHoldDialog?.()
        closeRejectDialog?.()
    }

    const handleSubmit = () => {
        if (allStaffIds.length === 0) {
            toast.error("No employee selected")
            return
        }

        if (!userId || userId === 0) {
            toast.error("User session invalid. Please log in again.")
            return
        }

        if (isRequestEdit && issuesToAddress.length === 0) {
            toast.error("Please select at least one issue")
            return
        }
        if (isHold && holdReason.length === 0) {
            toast.error("Please select a reason")
            return
        }
        if (isRejected && rejectedReason.length === 0) {
            toast.error("Please select a rejection reason")
            return
        }

        setIsSubmitting(true)
        setProcessedCount(0)
        setTotalCount(allStaffIds.length)

        const actionName = isApproved ? "approve" : isRejected ? "reject" : isRequestEdit ? "request_edit" : "hold";
        const requestData = {
            user_id: userId,
            userId: userId,
            staffIds: allStaffIds.map((id) => Number(id)),
            staff_ids: allStaffIds.map((id) => Number(id)),
            action: actionName,
            status: isApproved ? "approved" : isRejected ? "rejected" : isRequestEdit ? "revision" : "hold",
            financial_year: fy,
            financialYear: fy,
            remarks: updateStatus.hrNotesEdit || updateStatus.hrNotesHold || updateStatus.hrNotesReject || "No remarks",
            form12b_address_type: issuesToAddress.join(","),
            proof_id: holdReason.join(","),
            reject_form12b: rejectedReason.join(",")
        };

        dispatch(saveTdsStatusData({ path: manageTDSFormsPath, data: requestData }))
            .then(() => {
                setProcessedCount(allStaffIds.length);
                toast.success(`Processed ${allStaffIds.length} form(s)`);
                if (onActionComplete) {
                    onActionComplete(actionName, allStaffIds);
                }
                resetForm();
                closeApproveDialog?.();
                closeRequestEditDialog?.();
                closeHoldDialog?.();
                closeRejectDialog?.();
            })
            .catch(() => {
                setIsSubmitting(false);
            });
    }

    return (
        <div>
            {/* <ToastContainer position="top-right" autoClose={3000} /> */}

            {/* APPROVE DIALOG */}
      <Dialog
    width="sm"
    isOpen={isApproved}
    closeOpenDialog={closeApproveDialog}
    isHeader1={false}
    dialogTitle={
        <div className='d-flex align-items-center gap-3'>
            <div className='green-icon-container p-3' style={{ 
                borderRadius: '12px',
                background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 200, 100, 0.1) 100%)'
            }}>
                <CircleCheck class_name={"green-text"} style={{ fontSize: '24px' }} />
            </div>
            <div>
                <h3 className='color-white font-weight-500 mb-1'>Confirm Approval</h3>
                <p className='color-gray font-12 mb-0'>
                    {isBulk ? `${allStaffIds.length} employees selected` : 'Single approval'}
                </p>
            </div>
        </div>
    }
    body={
        <div className="form-wrapper">
            {/* Main Content Card */}
            <div className='setting-border height-auto p-4 mb-4' style={{
                background: 'linear-gradient(135deg, rgba(0, 255, 136, 0) 0%, rgba(30, 30, 50, 1) 100%)',
                borderRadius: '12px',
                border: '1px solid rgba(0, 255, 136, 0.2)'
            }}>
                <div className='text-center'>
                    {/* Icon */}
                    <div className='d-flex justify-content-center mb-3'>
                        <div style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            background: 'rgba(7, 245, 3, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid rgba(0, 255, 136, 0.84)'
                        }}>
                            <Check style={{ color: '#00ff88', fontSize: '32px' }} />
                        </div>
                    </div>

                    {/* Title */}
                    <h3 className='color-white font-weight-500 mb-2'>
                        {isBulk 
                            ? `Approve ${allStaffIds.length} Employees?` 
                            : `Approve ${getEmployeeName()}?`
                        }
                    </h3>

                    {/* Description */}
                    <p className='color-gray font-14 mb-0'>
                        {isBulk 
                            ? 'All selected TDS forms will be marked as approved and employees will be notified.'
                            : 'This TDS form will be marked as approved and the employee will be notified.'
                        }
                    </p>
                </div>
            </div>

            {/* Employee List Preview (for bulk) */}
            {isBulk && allStaffIds.length <= 5 && (
                <div className='mb-4'>
                    <p className='color-gray font-12 mb-2'>Selected Employees:</p>
                    <div className='d-flex flex-wrap gap-2'>
                        {selectedRows?.slice(0, 5).map((emp, idx) => (
                            <span key={idx} className='badge-purple-light px-3 py-1' style={{
                                borderRadius: '20px',
                                fontSize: '12px'
                            }}>
                                {emp.employeeName || emp.employeeId}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            {/* Action Buttons */}
            <div className='d-flex align-items-center gap-3 w-100'>
                <button 
                    className='universal-sec-btn d-flex align-items-center justify-content-center gap-2 flex-grow-1' 
                    onClick={cancel} 
                    disabled={isSubmitting}
                    style={{ 
                        padding: '12px 24px',
                        borderRadius: '8px'
                    }}
                >
                    <Cross size={16} /> Cancel
                </button>
                
                <button 
                    className='universal-btn d-flex align-items-center justify-content-center gap-2 flex-grow-1' 
                    onClick={handleSubmit} 
                    disabled={isSubmitting}
                    style={{ 
                        padding: '12px 24px',
                        borderRadius: '8px',
                        background: isSubmitting ? 'rgba(0, 255, 136, 0.3)' : 'linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)',
                        color: '#000',
                        fontWeight: '600'
                    }}
                >
                    {isSubmitting ? (
                        <>
                            <span className="spinner-border spinner-border-sm" />
                            <span>Processing {processedCount}/{totalCount}...</span>
                        </>
                    ) : (
                        <>
                            <Check size={16} /> 
                            Approve {isBulk && `(${allStaffIds.length})`}
                        </>
                    )}
                </button>
            </div>
        </div>
    }
/>

            {/* REQUEST EDIT DIALOG */}
            <Dialog
                width="md"
                isOpen={isRequestEdit}
                closeOpenDialog={closeRequestEditDialog}
                isHeader1={false}
                dialogTitle={
                    <div className='d-flex align-items-center gap-2'>
                        <span className='orange-icon-container'><PencilLine /></span>
                        <div>
                            <h3 className='color-white font-weight-200'>
                                Request Edit – Form 12BB
                                {isBulk && <span className='badge-orange ms-2'>{allStaffIds.length} selected</span>}
                            </h3>
                            <div className='d-flex align-items-center gap-2'>
                                <div className='font-12 color-gray d-flex align-items-center gap-1'>
                                    <UserLarge /> {getEmployeeName()}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                body={
                    <div className="form-wrapper">
                        <section>
                            <div className="section-header">
                                <TriangleExclamation class_name={"text-orange"} />
                                <h2 className='color-white'>Select Issues to Address <span className="required">*</span></h2>
                            </div>
                            <div className="checkbox-group">
                                <label className="checkbox-card">
                                    <input type="checkbox" value="1" onChange={handleAddress} checked={issuesToAddress.includes("1")} />
                                    <div className="checkbox-content">
                                        <div className="checkbox-title d-flex align-items-center justify-content-between gap-2">
                                            <h3 className='color-white font-weight-200'>Landlord PAN Missing</h3>
                                            <span className='badge-red border-radius-8px'><CircleExclamation /> Critical</span>
                                        </div>
                                        <p className="checkbox-description font-16 color-gray">Annual rent exceeds ₹1,00,000 but landlord PAN is not provided</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="2" onChange={handleAddress} checked={issuesToAddress.includes("2")} />
                                    <div className="checkbox-content">
                                        <div className="checkbox-title d-flex align-items-center justify-content-between gap-2">
                                            <h3 className='color-white font-weight-200'>Rent Receipts Not Uploaded</h3>
                                            <span className='badge-yellow border-radius-8px'><TriangleExclamation /> Warning</span>
                                        </div>
                                        <p className="checkbox-description font-16 color-gray">Missing rent receipts for claimed HRA exemption</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="3" onChange={handleAddress} checked={issuesToAddress.includes("3")} />
                                    <div className="checkbox-content">
                                        <div className="checkbox-title d-flex align-items-center justify-content-between gap-2">
                                            <h3 className='color-white font-weight-200'>Deduction Proof Mismatch</h3>
                                            <span className='badge-orange border-radius-8px'><Flag /> Review</span>
                                        </div>
                                        <p className="checkbox-description font-16 color-gray">Amount claimed doesn't match proof document</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="5" onChange={handleAddress} checked={issuesToAddress.includes("5")} />
                                    <div className="checkbox-content">
                                        <div className="checkbox-title d-flex align-items-center justify-content-between gap-2">
                                            <h3 className='color-white font-weight-200'>Other Issues</h3>
                                            <span className='badge-gray border-radius-8px'><PencilLine /> Custom</span>
                                        </div>
                                        <textarea
                                            name="otherIssuesForm12b"
                                            value={updateStatus.otherIssuesForm12b}
                                            onChange={handleInputChange}
                                            className='universal-input border-radius-8px mt-2 w-100'
                                            style={{ height: "80px" }}
                                            placeholder='Describe the issue...'
                                            disabled={!issuesToAddress.includes("5")}
                                        />
                                    </div>
                                </label>
                            </div>
                        </section>

                        <section className="mt-4">
                            <div className="section-header-purple d-flex align-items-center gap-2 mb-3 py-3">
                                <CommentDots class_name={"text-purple"} />
                                <h3 className='color-white font-weight-200'>HR Note <span className="required">*</span></h3>
                            </div>
                            <textarea
                                name="hrNotesEdit"
                                value={updateStatus.hrNotesEdit}
                                onChange={handleInputChange}
                                className="textarea color-white"
                                placeholder="Explain what the employee needs to do..."
                                rows="4"
                            />
                            <div className="textarea-footer mt-2">
                                <label className="checkbox-inline">
                                    <input type="checkbox" name="markUsUrgent" onChange={handleCheckBox} checked={updateStatus.markUsUrgent === "1"} />
                                    <span className="ms-1">Mark as urgent</span>
                                </label>
                                <label className="checkbox-inline ms-3">
                                    <input type="checkbox" name="ccToEmployeeManager" onChange={handleCheckBox} checked={updateStatus.ccToEmployeeManager === "1"} />
                                    <span className="ms-1">CC to manager</span>
                                </label>
                            </div>
                        </section>

                        <div className="audit-info d-flex align-items-center justify-content-between gap-2 mt-4">
                            <div className='d-flex align-items-center gap-2'>
                                <CircleInfo class_name={"color-gray"} />
                                <p className='mb-0 color-gray'>This will be logged in audit trail</p>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <button type='button' className='universal-sec-btn d-flex align-items-center gap-2' onClick={cancel} disabled={isSubmitting}>
                                    <Cross /> Cancel
                                </button>
                                <button type='button' className='universal-btn d-flex align-items-center gap-2' onClick={handleSubmit} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" />
                                            <span className="ms-2">Processing {processedCount}/{totalCount}...</span>
                                        </>
                                    ) : (
                                        <>
                                            <PaperPlane /> Send {isBulk && `(${allStaffIds.length})`}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            />

            {/* HOLD DIALOG */}
            <Dialog
                width="md"
                isOpen={isHold}
                closeOpenDialog={closeHoldDialog}
                isHeader1={false}
                dialogTitle={
                    <div className='d-flex align-items-center gap-2'>
                        <span className='yellow-icon-container'><Pause /></span>
                        <div>
                            <h3 className='color-white font-weight-200'>
                                Put On Hold
                                {isBulk && <span className='badge-yellow ms-2'>{allStaffIds.length} selected</span>}
                            </h3>
                            <div className='font-12 color-gray d-flex align-items-center gap-1'>
                                <UserLarge /> {getEmployeeName()}
                            </div>
                        </div>
                    </div>
                }
                body={
                    <div className="form-wrapper">
                        <div className="yellow-icon-container border-radius-8px yellow-border mb-3 p-3">
                            <div className='d-flex gap-2'>
                                <TriangleExclamation class_name={"yellow-text font-20"} />
                                <div>
                                    <h3 className='yellow-text font-weight-200'>Important</h3>
                                    <p className="font-14 yellow-text-2 mb-0">Payroll will be paused until resolved.</p>
                                </div>
                            </div>
                        </div>

                        <section>
                            <div className="section-header">
                                <Bars class_name={"text-purple"} />
                                <h2 className='color-white font-weight-200'>Reason for Hold <span className="required">*</span></h2>
                            </div>

                            <div className="checkbox-group">
                                <label className="checkbox-card">
                                    <input type="checkbox" value="1" onChange={handleHoldReason} checked={holdReason.includes("1")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Awaiting Proofs</h3>
                                        <p className="color-gray font-14">Employee needs to submit documentation</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="2" onChange={handleHoldReason} checked={holdReason.includes("2")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Awaiting Manager Review</h3>
                                        <p className="color-gray font-14">Requires manager approval</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="3" onChange={handleHoldReason} checked={holdReason.includes("3")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Awaiting HR Director</h3>
                                        <p className="color-gray font-14">Requires HR Director approval</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="4" onChange={handleHoldReason} checked={holdReason.includes("4")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Other</h3>
                                        <Form.Control
                                            name="otherIssuesProofs"
                                            value={updateStatus.otherIssuesProofs}
                                            onChange={handleInputChange}
                                            placeholder='Specify reason...'
                                            className='universal-input border-radius-8px mt-2'
                                            disabled={!holdReason.includes("4")}
                                        />
                                    </div>
                                </label>
                            </div>
                        </section>

                        <section className="mt-3">
                            <textarea
                                name='hrNotesHold'
                                value={updateStatus.hrNotesHold}
                                onChange={handleInputChange}
                                className="textarea color-white"
                                placeholder="Internal notes (optional)..."
                                rows="3"
                            />
                        </section>

                        <div className="audit-info d-flex align-items-center justify-content-between gap-2 mt-4">
                            <p className='mb-0 color-gray'><CircleInfo class_name={"color-gray"} /> Will be logged in audit trail</p>
                            <div className='d-flex align-items-center gap-2'>
                                <button type='button' className='universal-sec-btn d-flex align-items-center gap-2' onClick={cancel} disabled={isSubmitting}>
                                    <Cross /> Cancel
                                </button>
                                <button type='button' className='universal-btn-orange d-flex align-items-center gap-2' onClick={handleSubmit} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" />
                                            <span className="ms-2">Processing {processedCount}/{totalCount}...</span>
                                        </>
                                    ) : (
                                        <>
                                            <Pause /> Put On Hold {isBulk && `(${allStaffIds.length})`}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            />

            {/* REJECT DIALOG */}
            <Dialog
                width="md"
                isOpen={isRejected}
                closeOpenDialog={closeRejectDialog}
                isHeader1={false}
                dialogTitle={
                    <div className='d-flex align-items-center gap-2'>
                        <span className='red-icon-container'><Cross /></span>
                        <div>
                            <h3 className='color-white font-weight-200'>
                                Reject Form
                                {isBulk && <span className='badge-red ms-2'>{allStaffIds.length} selected</span>}
                            </h3>
                            <div className='font-12 color-gray d-flex align-items-center gap-1'>
                                <UserLarge /> {getEmployeeName()}
                            </div>
                        </div>
                    </div>
                }
                body={
                    <div className="form-wrapper">
                        <div className="alert alert-critical border-red mb-3 p-3">
                            <div className='d-flex gap-2'>
                                <TriangleExclamation class_name={"text-red font-20"} />
                                <div>
                                    <h3 className='text-red font-weight-200'>Warning</h3>
                                    <p className="color-gray-white mb-0">Employee must resubmit. This cannot be undone.</p>
                                </div>
                            </div>
                        </div>

                        <section>
                            <div className="section-header">
                                <Bars class_name={"text-purple"} />
                                <h2 className='color-white'>Rejection Reason <span className="required">*</span></h2>
                            </div>

                            <div className="checkbox-group">
                                <label className="checkbox-card">
                                    <input type="checkbox" value="1" onChange={handleRejectedReason} checked={rejectedReason.includes("1")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>False/Misleading Data</h3>
                                        <p className="color-gray font-14">Information appears inaccurate</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="2" onChange={handleRejectedReason} checked={rejectedReason.includes("2")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Invalid Proof</h3>
                                        <p className="color-gray font-14">Documents don't meet standards</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="3" onChange={handleRejectedReason} checked={rejectedReason.includes("3")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Policy Violation</h3>
                                        <p className="color-gray font-14">Violates company policy</p>
                                    </div>
                                </label>
                                <label className="checkbox-card">
                                    <input type="checkbox" value="4" onChange={handleRejectedReason} checked={rejectedReason.includes("4")} />
                                    <div className="checkbox-content">
                                        <h3 className='font-weight-200 color-white'>Other</h3>
                                        <input
                                            name="otherIssueReject"
                                            value={updateStatus.otherIssueReject}
                                            onChange={handleInputChange}
                                            className="universal-input border-radius-8px mt-2"
                                            placeholder="Specify reason..."
                                            disabled={!rejectedReason.includes("4")}
                                        />
                                    </div>
                                </label>
                            </div>
                        </section>

                        <section className="mt-3">
                            <textarea
                                name="hrNotesReject"
                                value={updateStatus.hrNotesReject}
                                onChange={handleInputChange}
                                className="textarea color-white"
                                placeholder="Justification for rejection..."
                                rows="3"
                            />
                        </section>

                        <div className="audit-info d-flex align-items-center justify-content-between gap-2 mt-4">
                            <p className='mb-0 color-gray'><ShieldHalved class_name={"color-gray"} /> Will be logged</p>
                            <div className='d-flex align-items-center gap-2'>
                                <button type='button' className='universal-sec-btn d-flex align-items-center gap-2' onClick={cancel} disabled={isSubmitting}>
                                    <Cross /> Cancel
                                </button>
                                <button type='button' className='universal-btn-red d-flex align-items-center gap-2' onClick={handleSubmit} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" />
                                            <span className="ms-2">Processing {processedCount}/{totalCount}...</span>
                                        </>
                                    ) : (
                                        <>
                                            <CircleXmark /> Reject {isBulk && `(${allStaffIds.length})`}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            />

            {/* IMPACT DIALOG */}
            <Dialog
                width="sm"
                isOpen={isImpact}
                closeOpenDialog={closeImpactDialog}
                isHeader1={false}
                dialogTitle={
                    <div className='d-flex align-items-center gap-2'>
                        <span className='purple-icon-container'><ChartLine class_name={"text-purple"} /></span>
                        <h3 className='color-white font-weight-200'>Impact Preview</h3>
                    </div>
                }
                body={
                    <div className="form-wrapper">
                        <Row>
                            <Col sm="6">
                                <div className='setting-border height-auto p-3'>
                                    <h3 className='text-purple'><center>247</center></h3>
                                    <span className='color-gray font-weight-200'><center>Employees</center></span>
                                </div>
                            </Col>
                            <Col sm="6">
                                <div className='setting-border height-auto p-3'>
                                    <h3 className='text-red'><center>₹24,700</center></h3>
                                    <span className='color-gray font-weight-200'><center>Total</center></span>
                                </div>
                            </Col>
                        </Row>
                        <div className='d-flex gap-2 mt-3'>
                            <button className='universal-btn flex-grow-1' onClick={submitImpactForm}><Check /> Proceed</button>
                            <button className='universal-sec-btn' onClick={closeImpactDialog}><Cross /> Cancel</button>
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default TdsDialoge